import { useState, useEffect } from "react";
import { UseMutateProps, UseMutateReturn } from "restful-react";
import { useSearchElasticStats, ElasticStatsSearchPayload, ElasticStatsSearchResponse } from "@coherehealth/qm-api";

/**
 * Wrapper around useMutate so it can be used with the useGet API
 * Does not yet support path params.
 * @param useMutateHook The original hook from restful-react
 * @param payload The body of the request
 */
export function useMutateAsGet<TData, TRequestBody, TError = unknown, TQueryParams = void, TPathParams = void>(
  useMutateHook: (
    props: Omit<UseMutateProps<TData, TError, TQueryParams, TRequestBody, TPathParams>, "path" | "verb">
  ) => UseMutateReturn<TData, TError, TRequestBody, TQueryParams, TPathParams>,
  payload: TRequestBody | null
) {
  const { mutate, error, loading } = useMutateHook({});
  const [data, setData] = useState<TData | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (payload) {
        const stats = await mutate(payload);
        setData(stats);
      }
    };
    fetchData();
  }, [payload, mutate, setData]);

  return {
    data,
    error,
    loading,
  };
}

// useMutateAsGet, typed for the Elastic Stats hook
export function useGetElasticStats(payload: ElasticStatsSearchPayload | null) {
  return useMutateAsGet<ElasticStatsSearchResponse, ElasticStatsSearchPayload>(useSearchElasticStats, payload);
}
